<span class="tbl-status" [ngClass]="'status-'+text?.toLowerCase()">{{text}}</span>
